module.exports = __webpack_public_path__ + "img/sms-icon.db341ac3.svg";